import React from "react";
import PropTypes from "prop-types";

import BodyScroll from "../BodyScroll";

const onCloseWrapper = ({ _onClose, onClose }) => {
  _onClose();
  if (typeof onClose === "function") {
    onClose();
  }
};

const ModalFull = props => {
  const { title, body, onClose, _onClose } = props;
  return (
    <div className="modal-skp modal-skp--solid">
      <BodyScroll isScroll />
      <div className="modal-skp__content anim-modal">
        {title && (
          <div className="modal-skp__head">
            <h3 className="modal-skp__title">{title}</h3>
          </div>
        )}
        {body && (
          <div className="modal-skp__body-alt modal-skp--scroll">{body}</div>
        )}
        <button
          className="modal-skp__close-alt"
          onClick={() => onCloseWrapper({ onClose, _onClose })}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
          >
            <path
              fill="#8F95A5"
              d="M16.067 15.182a.617.617 0 0 1 .183.442.62.62 0 0 1-.183.442.62.62 0 0 1-.682.136.62.62 0 0 1-.203-.136l-5.183-5.183-5.182 5.183a.626.626 0 1 1-.885-.884l5.184-5.183-5.184-5.183a.625.625 0 1 1 .885-.884l5.182 5.184 5.183-5.184a.629.629 0 0 1 .885 0 .625.625 0 0 1 0 .884l-5.184 5.183 5.184 5.183Z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

ModalFull.propTypes = {
  // passed through ModalController
  _onClose: PropTypes.func.isRequired,
  // passed in by alert action caller
  onClose: PropTypes.func,
  title: PropTypes.node,
  body: PropTypes.node
};

ModalFull.defaultProps = {
  title: null,
  body: null,
  onClose: null
};

export default ModalFull;



// WEBPACK FOOTER //
// ./src/components/ModalFull/ModalFull.js